export const allowedIpPermissionsConst = {
  view: {
    value: "view_allowedip",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu IP!",
  },
  add: {
    value: "add_allowedip",
    errorMsg: "Użytkownik nie ma uprawnień do dodania IP!",
  },
  update: {
    value: "change_allowedip",
    errorMsg: "Użytkownik nie ma uprawnień do edycji IP!",
  },
  delete: {
    value: "delete_allowedip",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania IP!",
  },
};
